import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import './libs';
import './styles/index.scss';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');


window.addEventListener("popstate",function(){
  history.pushState(null,null ,document.URL)
})
